import markupTpl from './markupTpl';
import apiService from './apiService';
import refs from './refs';

import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/dist/basicLightbox.min.css';

const API_KEY = '21713513-de4fa038d3971b80a05884d99';

let inputValue = '';
let page = 1;

refs.loadMore.style.display = 'none';

export const getSubmitForm = e => {
  e.preventDefault();
  refs.galleryList.innerHTML = '';
  inputValue = e.target.elements.query.value;
  if (inputValue.length === 0) {
    Notify.info('Sorry, there are no images matching your search query. Please try again.');
    return;
  }
  // scrollPage();
  page = 1;
  if (inputValue.length) {
    apiService(inputValue, page, API_KEY)
      .then(images => {
        images.length > 0
          ? (refs.loadMore.style.display = 'block')
          : (refs.loadMore.style.display = 'none');
        markupTpl(images);
      })
      .catch(error => console.log(error));
  }
};

export const moreImages = () => {
  page += 1;
  scrollPage();
  apiService(inputValue, page, API_KEY)
    .then(images => {
      markupTpl(images);
      scrollTo({
        top: document.documentElement.offsetHeight - 1600,
        behavior: 'smooth',
        block: 'end',
      });
    })
    .catch(error => caonsole.log(error));
};

export default function onOpenModal(event) {
  if (event.target.nodeName !== 'IMG') {
    return;
  }
  const instance = basicLightbox.create(`<img src="${event.target.dataset.src}" alt="" />`);
  instance.show();
}

refs.galleryList.addEventListener('click', onOpenModal);
refs.form.addEventListener('submit', getSubmitForm);
refs.loadMore.addEventListener('click', moreImages);

function scrollPage() {
  try {
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }, 1000);
  } catch (error) {
    console.log(error);
  }
}
